export const CHECKOUT_MODES = {
  Trial: 'trial',
  Subscription: 'subscription',
  Cart: 'cart',
} as const;

export type CheckoutMode = valueof<typeof CHECKOUT_MODES>;
